import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

const authOnlyHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
      }
    : {};
};

export async function listStaff(params = {}, token) {
  const res = await axios.get(`${API}/staffs`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getStaff(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getStaffKpiProgress(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}/kpi-progress`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createStaff(data, token) {
  const res = await axios.post(`${API}/staffs`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateStaff(staffId, data, token) {
  const res = await axios.put(`${API}/staffs/${staffId}`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function uploadStaffPhoto(staffId, file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`${API}/staffs/${staffId}/photo`, formData, {
    headers: authOnlyHeaders(token),
  });
  return res.data;
}

export async function removeStaffPhoto(staffId, token) {
  const res = await axios.delete(`${API}/staffs/${staffId}/photo`, {
    headers: authOnlyHeaders(token),
  });
  return res.data;
}

export async function reorderStaff(payload, token) {
  const res = await axios.post(`${API}/staffs/reorder`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteStaff(staffId, token) {
  await axios.delete(`${API}/staffs/${staffId}`, {
    headers: authHeaders(token),
  });
}

export async function getStaffSchedule(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}/schedule`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateStaffSchedule(staffId, weeklySchedule, token) {
  await axios.put(
    `${API}/staffs/${staffId}/schedule`,
    { weekly_schedule: weeklySchedule },
    {
      headers: authHeaders(token),
    }
  );
}

export async function getStaffLogin(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}/login`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function resetStaffCredentials(staffId, payload, token) {
  const res = await axios.post(
    `${API}/staffs/${staffId}/reset-credentials`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function createStaffLogin(staffId, payload, token) {
  const res = await axios.post(
    `${API}/staffs/${staffId}/create-login`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getStaffServices(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}/services`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateStaffServices(staffId, payload, token) {
  const res = await axios.put(`${API}/staffs/${staffId}/services`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function copyStaffServices(staffId, payload, token) {
  const res = await axios.post(
    `${API}/staffs/${staffId}/services/copy`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getStaffClientSatisfaction(staffId, token) {
  const res = await axios.get(`${API}/staffs/${staffId}/client-satisfaction`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createStaffCoachingNote(staffId, payload, token) {
  const res = await axios.post(`${API}/staffs/${staffId}/coaching-notes`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function assignTrainingFromFeedback(staffId, payload, token) {
  const res = await axios.post(
    `${API}/staffs/${staffId}/training-assignments/from-feedback`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}
